import FileUpload from "./index.vue";

FileUpload.install = Vue => Vue.component(FileUpload.componentName, FileUpload);

export default FileUpload;
